import { createRef, Component } from 'react';
import { inject, observer } from 'mobx-react';
import propTypes from 'prop-types';

import * as constants from '../../constants/constants';
import { ExtraMenuContent } from './ExtraMenuContent.jsx';

class _ExtraMenu extends Component {
  constructor(props) {
    super(props);
    this.ref = createRef();
  }

  handleMenuClick = (e) => {
    // Don't close if info icon pressed
    if (e.target.hasAttribute('data-stayopen')) {
      return;
    }

    const { ID, uiStore } = this.props;

    const bounds = this.ref.current.getBoundingClientRect();
    const nextValue = uiStore.extraMenuID === ID
      ? null
      : ID;
    const maxWidth = (nextValue && uiStore.isMobile)
      ? this.calcWidth(bounds)
      : 'auto';

    uiStore.handleExtraMenu(nextValue, maxWidth);
  };

  calcWidth = (bounds) => {
    if (document.documentElement.dir === 'rtl') {
      return document.body.clientWidth - constants.MOBILE_INTEND;
    }

    return bounds.right - constants.MOBILE_INTEND;
  };

  handleOverlayCLick = (event) => {
    if (event.target !== event.currentTarget) {
      return true;
    }

    const { uiStore } = this.props;

    uiStore.handleExtraMenu(null, 0);
    event.stopPropagation();
    return false;
  };

  render() {
    const { uiStore, ID, children, documentsStore } = this.props;
    const isOpenedClass = uiStore.extraMenuID === ID
      ? 'opened'
      : '';

    const subMenu = isOpenedClass && (
      <ExtraMenuContent handleOverlayCLick={this.handleOverlayCLick}>{children}</ExtraMenuContent>
    );

    const isLoading = documentsStore.isLoading ? 'pes-icon-dots--loading' : '';

    return (
      // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
      <div className={`pes-icon-dots ${isOpenedClass} ${isLoading}`} onClick={this.handleMenuClick} ref={this.ref}>
        <i />
        <i />
        <i />
        {subMenu}
      </div>
    );
  }
}

_ExtraMenu.propTypes = {
  uiStore: propTypes.shape({
    extraMenuID: propTypes.string,
    handleExtraMenu: propTypes.func,
    extraMenuWidth: propTypes.oneOfType([
      propTypes.string,
      propTypes.number
    ]),
    isMobile: propTypes.bool
  }),

  documentsStore: propTypes.shape({
    isLoading: propTypes.bool.isRequired
  }),

  ID: propTypes.string.isRequired,
  children: propTypes.element
};

export const ExtraMenu = inject((allStores) => ({
  uiStore: allStores.uiStore,
  documentsStore: allStores.documentsStore
}))(observer(_ExtraMenu));
